import { useCallback, useRef } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { LanternIcon } from 'src/assets/icons/Lantern';
import { TextLink } from 'src/components/TextLink';
import { TEST_ID } from 'src/data/dom';

import { useStyles } from './useStyles';

export const LockedScoreButtons = ({
  className,
  onGetScoreClick,
  onUndoClick,
  vertical,
  small,
  disabled,
  hideUndo,
  generationToolIcon,
}) => {
  const styles = useStyles();

  const rootRef = useRef(null);

  const handleGetScoreClick = useCallback(
    (event) => {
      event.stopPropagation();
      onGetScoreClick(rootRef.current);
    },
    [onGetScoreClick]
  );

  const handleUndoClick = useCallback(
    (event) => {
      event.stopPropagation();
      onUndoClick();
    },
    [onUndoClick]
  );

  return (
    <div
      className={cx(styles.root, className, {
        [styles.vertical]: vertical,
        [styles.small]: small,
      })}
      ref={rootRef}
      data-testid="LockedScoreButtons"
    >
      <LanternIcon className={styles.lanternIcon} />

      <Button
        className={styles.buttonGetScore}
        onClick={handleGetScoreClick}
        disabled={disabled}
        variant="text"
        color="primary"
        size="small"
        data-testid={TEST_ID.getScoreButton}
      >
        Get score
      </Button>

      {generationToolIcon}

      {!hideUndo && (
        <Tooltip title="Revert back to original copy with score">
          <TextLink
            className={styles.buttonUndo}
            onClick={handleUndoClick}
            disabled={disabled}
            component="button"
            data-testid="scoreRevertButton"
          >
            Revert
          </TextLink>
        </Tooltip>
      )}
    </div>
  );
};

LockedScoreButtons.propTypes = {
  className: PropTypes.string,
  onGetScoreClick: PropTypes.func.isRequired,
  onUndoClick: PropTypes.func,
  vertical: PropTypes.bool,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  hideUndo: PropTypes.bool,
  generationToolIcon: PropTypes.node,
};

LockedScoreButtons.defaultProps = {
  className: '',
  onUndoClick: null,
  vertical: false,
  small: false,
  disabled: false,
  hideUndo: false,
  generationToolIcon: null,
};
